import { Category } from 'router/routes';

export const getCompanyIdAndCategory = (
  pathname: string,
): { companyId: number; category: Category } | undefined => {
  if (pathname.includes('company')) {
    const splittedPaths = pathname.split('/');
    return {
      companyId: +splittedPaths[splittedPaths.length - 2],
      category: splittedPaths[splittedPaths.length - 1] as Category,
    };
  }

  return undefined;
};

export const searchFilterChanged = (previousSearchValue: string, currentSearchValue: string) => {
  if (
    previousSearchValue !== currentSearchValue.trim() &&
    (Boolean(previousSearchValue.trim()) || Boolean(currentSearchValue.trim()))
  ) {
    return true;
  }

  return false;
};

export const convertBytesToMb = (bytes: number) => {
  return (bytes / 1000000).toFixed(1);
};

export const validateFileType = (fileName: string, accept: string) => {
  const splittedFileName = fileName.split('.');
  return accept.includes(splittedFileName[splittedFileName.length - 1]);
};

export const validateAllFilesType = (files: File[], accept: string) => {
  let allFilesTypeValid = true;

  files.forEach((selectedFile) => {
    if (!validateFileType(selectedFile.name, accept)) {
      allFilesTypeValid = false;
    }
  });

  return allFilesTypeValid;
};

export const getContentType = (type: string) => {
  if (type.startsWith('image/')) {
    return 'image';
  }

  return 'video';
};

export const getFileNameFromUrl = (url: string) => {
  return url.slice(url.lastIndexOf('/') + 1);
};
